/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LixiApplicationResponseBaseResponse as ModelsV3ApplicationLixiApplicationResponseBaseResponse } from '../../models/Models/v3/Application/lixi-application-response-base-response';
import { LoanProductEnum as ModelsV3ApplicationLoanProductEnum } from '../../models/Models/v3/Application/loan-product-enum';

export interface V3ApplicationLixiProductUuidPost$Json$Params {
  product: ModelsV3ApplicationLoanProductEnum;
  uuid: string;
      body?: Array<any>
}

export function v3ApplicationLixiProductUuidPost$Json(http: HttpClient, rootUrl: string, params: V3ApplicationLixiProductUuidPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3ApplicationLixiProductUuidPost$Json.PATH, 'post');
  if (params) {
    rb.path('product', params.product, {});
    rb.path('uuid', params.uuid, {});
    rb.body(params.body, 'application/xml');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsV3ApplicationLixiApplicationResponseBaseResponse>;
    })
  );
}

v3ApplicationLixiProductUuidPost$Json.PATH = '/v3/application/lixi/{product}/{uuid}';
